import Cookies from "js-cookie";

export const USER_DATA_COOKIE_NAME = "userData";

/**
 * Options communes pour supprimer les cookies de session (`userData`, `access`, `token`),
 * alignées sur le logout (`UserContext`) afin que le navigateur retire bien les cookies
 * posés avec `path` + `sameSite` + `secure`.
 */
export function getSessionCookieRemoveOptions() {
  return {
    path: "/",
    sameSite: "Lax",
    secure: typeof window !== "undefined" && window.location?.protocol === "https:",
  };
}

/** Supprime le cookie session utilisateur (options typiquement `{ path: "/", sameSite, secure }`). */
export function removeUserDataCookie(options) {
  Cookies.remove(USER_DATA_COOKIE_NAME, options);
}

/** Objet session depuis le cookie `userData`, ou `null` si absent / vide / JSON invalide (ex. état initial `UserContext`). */
export function parseUserDataCookieOrNull() {
  try {
    const userCookie = Cookies.get(USER_DATA_COOKIE_NAME);
    if (typeof userCookie !== "string" || !userCookie.trim()) {
      return null;
    }
    return JSON.parse(userCookie);
  } catch {
    return null;
  }
}

/** Objet session depuis le cookie `userData` (défaut `{ id: 0 }` si absent / JSON invalide). */
export function parseUserDataCookie() {
  return parseUserDataCookieOrNull() ?? { id: 0 };
}

/** `id` utilisateur depuis le cookie `userData` (0 si absent ou JSON invalide). */
export function getUserIdFromUserDataCookie() {
  const n = Number(parseUserDataCookie()?.id);
  return Number.isFinite(n) ? n : 0;
}
